import { useConnect } from '@lore/query-connect';
import { offer_networkId } from '@/utils/query-helpers';

export default function useClaims(network, schoolStart, schoolEnd, extra = {}) {
  return useConnect('claim.find', {
    where: {
      eager: {
        $where: {
          ...offer_networkId(network),
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          request: { $not: 'Outreach' },
          ...extra
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });
}
